export const LABELS = {
  ERROR_DETAIL: "エラー内容",
  ERROR_OCCURRED_PLACE: "エラー発生箇所",
  NO: "No",
  SITE_ID: "サイトID",
  COMPANY_CODE: "企業コード",
  OCCURRED_PLACE: "発生箇所",
  ERROR_TEXT_LABEL1:
    "サイトIDと企業コードのサイトID部分が一致しません。申請内容についてご確認ください。",
  ERROR_TEXT_LABEL2: "修正する場合はキャンセルを押下してください。",  
} as const;

export const CONFIGS = {
  SEPARATOR: "（",
} as const;

export const CONTENTS = {
  ERROR_ROW: "(不備行：{0}行目)",
};
